import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTeacherAnalytics } from "../api/services";
import {
  MdClass,
  MdMenuBook,
  MdAssignment,
  MdAssessment,
  MdCalendarMonth
} from "react-icons/md";

function TeacherDashboard() {


  const { t, i18n } = useTranslation();

const changeLanguage = (lang) => {

  i18n.changeLanguage(lang);

  localStorage.setItem(
    "language",
    lang
  );
};

  const [stats, setStats] = useState(null);
  const isDean =
  localStorage.getItem("is_dean") === "true";

  const username = localStorage.getItem(
    "username"
  );

  useEffect(() => {

    fetchStats();

  }, []);

  const fetchStats = async () => {

    try {

      const res = await getTeacherAnalytics();

      setStats(res.data);

    } catch (err) {

      console.error(
        "Failed to load analytics",
        err
      );
    }
  };

  if (!stats)

    return (

      <p style={{ padding:30 }}>
        Loading dashboard...
      </p>
    );

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <div>

  <div
    style={{
      color:"rgba(255,255,255,.85)",
      fontSize:22,
      marginBottom:8
    }}
  >
    {t("Welcome")},
  </div>

  <div
    style={{
      color:"white",
      fontSize:42,
      fontWeight:"800",
      marginBottom:12
    }}
  >
    {username}.
  </div>

  <div
    style={{
      color:"rgba(255,255,255,.92)",
      fontSize:22
    }}
  >
  
  </div>

  <h1 style={styles.title}>
    {t("teacherDashboard")}
  </h1>

</div>

        <div style={styles.headerBtns}>


          <button
  style={styles.languageBtn}
  onClick={() =>
    changeLanguage(
      i18n.language === "en"
        ? "fr"
        : "en"
    )
  }
>
  {i18n.language === "en"
    ? "🇫🇷 FR"
    : "🇬🇧 EN"}
</button>

<a
  href="https://api.eduskot.com/admin/"
  target="_blank"
  rel="noopener noreferrer"
  style={styles.adminShortcutBtn}
>
  ⚙️ Config
</a>

          <button
            style={styles.primaryBtn}
            onClick={() =>
              (
                window.location.href =
                "/teacher/my-assignments"
              )
            }
          >
            + {t("enterMarks")}
          </button>



          <button
            style={styles.logout}
            onClick={() => {

              localStorage.clear();

              window.location.href = "/";
            }}
          >
            {t("logout")}
          </button>

        </div>

      </div>

      {/* ANALYTICS CARDS */}

      <div style={styles.grid}>

        <Card
          title={t("assignedClasses")}
          value={stats.total_classes}
        />

        <Card
          title={t("assignedSubjects")}
          value={stats.total_subjects}
        />

        <Card
          title={t("marksEntered")}
          value={stats.total_marks_entered}
        />

        <Card
          title={t("assessments")}
          value={stats.total_assessments}
        />

        <div style={styles.fullWidthCard}>
  <Card
    title={t("activeTerm")}
    value={stats.active_term || "-"}
  />
</div>

      </div>


    

  


    </div>


            



  );
}

/* ===================================================== */
/* REUSABLE CARD */
/* ===================================================== */

function Card({ title, value }) {

  const { t } = useTranslation();

  const items = {

  [t("assignedClasses")]:{
    icon:<MdClass size={30}/>,
    color:"#2563eb"
  },

  [t("assignedSubjects")]:{
    icon:<MdMenuBook size={30}/>,
    color:"#22c55e"
  },

  [t("marksEntered")]:{
    icon:<MdAssignment size={30}/>,
    color:"#f59e0b"
  },

  [t("assessments")]:{
    icon:<MdAssessment size={30}/>,
    color:"#8b5cf6"
  },

  [t("activeTerm")]:{
    icon:<MdCalendarMonth size={30}/>,
    color:"#ef4444"
  }

};

const item = items[title] || {
  icon:<MdMenuBook size={30}/>,
  color:"#2563eb"
};
  return (

    <div style={styles.card}>

      {/* Decorative Circle */}
      <div
        style={{
          position:"absolute",
          top:-25,
          right:-25,
          width:75,
          height:75,
          background:item.color + "10",
          borderRadius:"50%"
        }}
      />

      {/* Decorative Dots */}
      <div
        style={{
          position:"absolute",
          top:12,
          right:16,
          color:item.color,
          fontSize:18,
          letterSpacing:2,
          fontWeight:"900",
          lineHeight:"12px"
        }}
      >
        •••
        <br/>
        &nbsp;&nbsp;••
      </div>

      {/* Icon */}
<div
  style={{
    width:64,
    height:64,
    borderRadius:"18px",
    background:item.color + "18",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    color:item.color,
    boxShadow:`0 8px 20px ${item.color}25`,
    fontSize:30,
    marginBottom:18
  }}
>
  {item.icon}
</div>

      {/* Value */}
      <div
        style={{
          fontSize:46,
          fontWeight:"900",
          marginTop:18,
          color:"#0f172a"
        }}
      >
        {value}
      </div>

      {/* Title */}
      <div
        style={{
          marginTop:6,
          fontSize:17,
          fontWeight:"600",
          color:"#5b6475",
          lineHeight:"22px"
        }}
      >
        {title}
      </div>

      {/* Bottom Line */}
      <div
        style={{
          width:55,
          height:4,
          borderRadius:30,
          background:item.color,
          marginTop:18
        }}
      />

    </div>

  );

}
/* ===================================================== */
/* STYLES */
/* ===================================================== */

const styles = {

  page:{
    padding: window.innerWidth < 768 ? "8px" : "17px",
    fontFamily:
      "Inter, Segoe UI, sans-serif",
    background:"#f8fafc",
    minHeight:"100vh",
  },

  header:{
    background:"linear-gradient(135deg,#5b2eff,#2563eb)",
    color:"white",
    padding:"35px 25px 45px",
    margin:"-32px -32px 30px",
    borderBottomLeftRadius:"60px",
    borderBottomRightRadius:"60px",
    position:"relative"
},

 headerBtns:{
    display:"flex",
    gap:"12px",
    flexWrap:"wrap",
    marginTop:"25px"
},

title:{
    marginTop:"6px",
    marginBottom:"0px",
    fontSize:"52px",
    fontWeight:"900",
    color:"white",
    lineHeight:"55px"
},


adminShortcutBtn:{
  padding:"12px 18px",
  background:"linear-gradient(135deg,#7c3aed,#8b5cf6)",
  color:"white",
  border:"none",
  borderRadius:"10px",
  fontWeight:"700",
  cursor:"pointer",
  textDecoration:"none",
  display:"inline-flex",
  alignItems:"center",
  justifyContent:"center",
  minHeight:"45px",
  boxSizing:"border-box",
  boxShadow:
    "0 6px 18px rgba(37,99,235,0.22)"
},

  subtitle:{
    marginTop:"8px",
    color:"rgba(255,255,255,.92)",
    fontSize:"20px",
    fontWeight:"500"
},


  primaryBtn:{
    padding:"12px 18px",
    background:"#2563eb",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer",
    boxShadow:
      "0 6px 18px rgba(37,99,235,0.25)",
  },

  logout:{
    padding:"12px 18px",
    background:"#ef4444",
    color:"white",
    border:"none",
    borderRadius:"10px",
    fontWeight:"600",
    cursor:"pointer",
  },


  deanSection:{
  marginTop:"40px",
},

deanTitle:{
  marginBottom:"20px",
  color:"#1e40af",
},

  languageBtn:{
  padding:"12px 18px",
  background:"#3973e7bf",
  color:"white",
  border:"none",
  borderRadius:"10px",
  fontWeight:"600",
  cursor:"pointer",
  height:"45px"
},

grid:{
  display:"grid",
  gridTemplateColumns:
    window.innerWidth < 768
      ? "repeat(2,1fr)"
      : "repeat(auto-fit,minmax(220px,1fr))",
  gap:"18px",
  marginTop:"25px"
},

fullWidthCard:{
  gridColumn:"1 / -1"
},
  card:{
    background:"#fff",
    padding:"18px",
    borderRadius:"22px",
    boxShadow:"0 12px 30px rgba(34,87,122,.12)",
    textAlign:"left",
    height:185,
    position:"relative",
    overflow:"hidden",
    borderTopRightRadius:"30px",
},

  cardValue:{
    fontSize:"30px",
    fontWeight:"700",
    marginBottom:"8px",
    color:"#0f172a"
  },

  cardTitle:{
    color:"#64748b",
    fontSize:"14px",
    fontWeight:"500"
  }
};

export default TeacherDashboard;